import AionApp from './aion/aionApp';


export {
    AionApp
}